import type { SVGProps } from 'react'

export function ChartDown(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.3962 15.2291C29.0335 15.2291 28.6709 15.0903 28.3946 14.814L17.4154 3.83486C16.8615 3.28095 16.8615 2.38561 17.4154 1.8317C17.9694 1.27778 18.8647 1.27778 19.4186 1.8317L30.3978 12.8109C30.9517 13.3648 30.9517 14.2601 30.3978 14.814C30.1215 15.0903 29.7589 15.2291 29.3962 15.2291Z"
        fill="currentColor"
      />
      <path
        d="M30.1049 15.5834H25.1466C24.7173 15.5834 24.3292 15.3241 24.1648 14.9275C24.0005 14.5308 24.0912 14.0732 24.3958 13.77L29.3541 8.81171C29.6587 8.50854 30.1148 8.41646 30.5115 8.58079C30.9082 8.74513 31.1674 9.13329 31.1674 9.56254V14.5209C31.1674 15.1074 30.6914 15.5834 30.1049 15.5834Z"
        fill="currentColor"
      />
      <path
        d="M32.584 21.6042V29.75H24.084V21.6042C24.084 20.6267 24.8773 19.8334 25.8548 19.8334H30.8132C31.7907 19.8334 32.584 20.6267 32.584 21.6042Z"
        fill="currentColor"
      />
      <path
        d="M21.25 15.9375V29.75H12.75V15.9375C12.75 14.96 13.5433 14.1666 14.5208 14.1666H19.4792C20.4567 14.1666 21.25 14.96 21.25 15.9375Z"
        fill="currentColor"
      />
      <path
        d="M9.91602 10.2708V29.75H1.41602V10.2708C1.41602 9.29333 2.20935 8.5 3.18685 8.5H8.14518C9.12268 8.5 9.91602 9.29333 9.91602 10.2708Z"
        fill="currentColor"
      />
      <path
        d="M32.9375 34H1.0625C0.476 34 0 33.524 0 32.9375C0 32.351 0.476 31.875 1.0625 31.875H32.9375C33.524 31.875 34 32.351 34 32.9375C34 33.524 33.524 34 32.9375 34Z"
        fill="currentColor"
      />
    </svg>
  )
}
